const ButtonLoader = ({ size = "sm", color = "dark" }) => {
  const spinnerClass = `spinner-border spinner-border-${size} text-${color}`;

  return <span className={spinnerClass} role="status" aria-hidden="true" />;
};

export default ButtonLoader;
